import React from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa6";

interface FooterProps {
  className?: string;
  handleMenuClick?: (page: string) => void;
}

const Footer: React.FC<FooterProps> = ({ className, handleMenuClick }) => {
  const IconWa = FaWhatsapp as React.FC<React.SVGProps<SVGSVGElement>>;
  return (
    <footer className={`bg-white text-black font-poppins border-t-4 border-primary ${className}`}>
      <div className="flex justify-center mt-4 gap-4 items-center">
        <img src="/images/logo_peduli.png" alt="" className="w-12 h-12" />
        <p className="font-bilbo text-3xl font-bold">X</p>
        <img src="/images/bk.png" alt="" className="w-11 h-12" />
      </div>
      <span className="text-primary"></span>
      <span className="text-primary"></span>
      <div className="max-sm:mx-4 lg:mx-44 my-4 text-center max-sm:text-xs text-sm ">
        Website ini bagian tak terpisahkan dari Platform{" "}
        <Link to="https://belaskasih.com">
          <span className="text-primary">BelasKasih.com</span>
        </Link>{" "}
        milik Yayasan Belas Kasih Insani Kami adalah yayasan sosial yang bergerak di bidang program kemanusiaan, sosial, pendidikan, dan kesehatan secara digital. Platform Belas Kasih dikelola oleh{" "}
        <span className="text-primary">PT Belas Kasih Indonesia</span> sesuai dengan badan hukum di negara Republik Indonesia
      </div>

      <div className="flex justify-center gap-1 items-center font-bold mb-4 max-sm:text-xs text-sm">
        <Link to="https://policies.belaskasih.com/term-of-services" className="underline">
          Syarat & Ketentuan
        </Link>
        |
        <Link to="https://policies.belaskasih.com/kebijakan-privasi" className="underline">
          Kebijakan Privasi
        </Link>
        |
        <Link to="https://policies.belaskasih.com/frequently-asked-questions" className="underline">
          Pusat Bantuan
        </Link>
      </div>

      <div className="flex justify-center gap-1 items-center my-2 max-sm:text-xs text-sm">
        CP :
        <span className="text-primary  ">
          <IconWa />
        </span>
        <Link target="_blank" to="https://wa.me/6282124415600">
          {" "}
          <span className="text-primary"> 082124415600</span>
        </Link>
      </div>
      <div className="mx-4">
        <hr />
      </div>
      <div className="text-center py-5 text-black text-[12px] md:text-base border-t border-gray-300">
        <p className="font-medium">
          © 2025 <span className="font-bilbo text-primary">Peduli Sumatera</span> part of <span className="text-primary font-semibold">Belas Kasih</span> | All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
